(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews-nw"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const tabs = document.querySelectorAll('.tab-nav a');
        const tabContents = document.querySelectorAll('.tab-content');

        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                event.preventDefault();

                tabs.forEach(tab => tab.classList.remove('active'));
                tabContents.forEach(content => content.classList.remove('active'));
                this.classList.add('active');
                const target = document.querySelector(this.getAttribute('href'));
                target.classList.add('active');
            });
        });
    });
    const NWCustomerReviewSlider = new Swiper(".NWCustomerReviewSlider", {
        slidesPerView: 2,
        spaceBetween: 0,
        loop: false,
        navigation: {
            nextEl: ".NW-CustomerReview__slider .swiper-button-next",
            prevEl: ".NW-CustomerReview__slider .swiper-button-prev",
        },
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        breakpoints: {
          1: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
        },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const tabs = document.querySelectorAll('.tab-nav a');
        const tabContents = document.querySelectorAll('.tab-content');

        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                event.preventDefault();

                tabs.forEach(tab => tab.classList.remove('active'));
                tabContents.forEach(content => content.classList.remove('active'));
                this.classList.add('active');
                const target = document.querySelector(this.getAttribute('href'));
                target.classList.add('active');
            });
        });
    });
    const NWCustomerReviewSlider = new Swiper(".NWCustomerReviewSlider", {
        slidesPerView: 2,
        spaceBetween: 0,
        loop: false,
        navigation: {
            nextEl: ".NW-CustomerReview__slider .swiper-button-next",
            prevEl: ".NW-CustomerReview__slider .swiper-button-prev",
        },
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        breakpoints: {
          1: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
        },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-slider-nw"] && !Shopify.designMode) return;
  try {
    
    if(window.innerWidth <= 749) {
        const NWGridSlider = new Swiper(".NWGridSlider", {
            slidesPerView: 'auto',
            spaceBetween: 17,
            // loop: true,
            centeredSlides: true,
            pagination: {
              el: ".swiper-pagination",
            },
            autoplay: {
              delay: 3500,
              disableOnInteraction: false,
            },
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-slider"] && !Shopify.designMode) return;
  try {
    
    if(window.innerWidth <= 749) {
        const NWGridSlider = new Swiper(".NWGridSlider", {
            slidesPerView: 'auto',
            spaceBetween: 17,
            // loop: true,
            centeredSlides: true,
            pagination: {
              el: ".swiper-pagination",
            },
            autoplay: {
              delay: 3500,
              disableOnInteraction: false,
            },
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-ingredients"] && !Shopify.designMode) return;
  try {
    
    if(window.innerWidth <= 749) {
        const NWIngredientsSlider = new Swiper(".NWIngredientsSlider", {
            slidesPerView: 'auto',
            spaceBetween: 15,
            // navigation: {
            //     nextEl: ".swiper-button-next",
            //     prevEl: ".swiper-button-prev",
            // },
            pagination: {
              el: ".swiper-pagination",
            },
            // loop: true,
            // centeredSlides: true,
            // autoplay: {
            //   delay: 3500,
            //   disableOnInteraction: false,
            // },
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-nw"] && !Shopify.designMode) return;
  try {
    
    const NWTestimonialsSlider = new Swiper(".NWTestimonialsSlider", {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: ".NW-Testimonials__slider .swiper-button-next",
            prevEl: ".NW-Testimonials__slider .swiper-button-prev",
        },
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
    const NWTestimonialsSlider = new Swiper(".NWTestimonialsSlider", {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: ".NW-Testimonials__slider .swiper-button-next",
            prevEl: ".NW-Testimonials__slider .swiper-button-prev",
        },
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-science-explained-nw"] && !Shopify.designMode) return;
  try {
    
    if(window.innerWidth <= 749) {
        const NWScienceSlider = new Swiper(".NWScienceSlider", {
            slidesPerView: 'auto',
            spaceBetween: 0,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            // loop: true,
            // centeredSlides: true,
            // pagination: {
            //   el: ".swiper-pagination",
            // },
            // autoplay: {
            //   delay: 3500,
            //   disableOnInteraction: false,
            // },
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-science-explained"] && !Shopify.designMode) return;
  try {
    
    if(window.innerWidth <= 749) {
        const NWScienceSlider = new Swiper(".NWScienceSlider", {
            slidesPerView: 'auto',
            spaceBetween: 0,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            // loop: true,
            // centeredSlides: true,
            // pagination: {
            //   el: ".swiper-pagination",
            // },
            // autoplay: {
            //   delay: 3500,
            //   disableOnInteraction: false,
            // },
        });
    }

  } catch(e) { console.error(e); }
})();
})();
